import { formatDate } from "./formatDate";

export const formatDateTime = (
  dateTime: Date,
  formatString = "dd/MM/yyyy h:mm a"
): string => {
  return formatDate(dateTime, formatString);
};
